var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicketsV2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.274 7.15l.53.531a.75.75 0 000-1.06l-.53.53zm2.828 2.83l.53-.531a.75.75 0 00-1.06 0l.53.53zm-6.894-4.067l-7.071 7.071 1.06 1.061 7.072-7.071-1.061-1.06zm3.889 0a2.75 2.75 0 00-3.89 0l1.061 1.061a1.25 1.25 0 011.768 0l1.061-1.06zm.707.707l-.707-.707-1.06 1.061.706.707 1.061-1.06zm-1.06 0a2.75 2.75 0 000 3.89l1.06-1.061a1.25 1.25 0 010-1.768l-1.06-1.06zm0 3.89a2.75 2.75 0 003.889 0l-1.061-1.061a1.25 1.25 0 01-1.768 0l-1.06 1.06zm4.596-.354l-.707-.707-1.061 1.06.707.708 1.06-1.061zm0 3.89a2.75 2.75 0 000-3.89l-1.061 1.06a1.25 1.25 0 010 1.768l1.06 1.061zm-1.415 1.413l1.415-1.414-1.061-1.06-1.414 1.414 1.06 1.06zm-5.657 5.657l5.657-5.657-1.06-1.06-5.657 5.656 1.06 1.061zm-3.889 0a2.75 2.75 0 003.89 0l-1.061-1.06a1.25 1.25 0 01-1.768 0l-1.06 1.06zm-1.849-1.85l1.85 1.85 1.06-1.06-1.85-1.85-1.06 1.06zm-2.393-2.392l2.393 2.393 1.06-1.06-2.393-2.394-1.06 1.06zm0-3.89a2.75 2.75 0 000 3.89l1.06-1.061a1.25 1.25 0 010-1.768l-1.06-1.06z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.948 8.645l6.71 6.71",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.966 18.114l-.483-.13a2 2 0 01-1.414-2.449l2.588-9.659a2 2 0 012.45-1.414l.965.259a2 2 0 00.618 2.026M5.968 8.869l1.289.345m3.373.903l-1.042-.279",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgTicketsV2;